import React from 'react';
import type { CartEmptyProps } from './cart-empty.types';
import { cn } from '../../../lib/utils';
import Image from '../../atoms/image';
import Text from '../../atoms/text';
import Button from '../../atoms/button';
import styles from './cart-empty.module.css';
import Card from '../card';

export const CartEmpty: React.FC<CartEmptyProps> = ({
    imageProps,
    descriptionContent,
    descriptionProps,
    buttonProps,
    containerClassName,
}) => {
    return (
        <Card className={cn(styles.container, containerClassName)}>
            {imageProps?.src && (
                <Image
                    {...imageProps}
                    className={cn(styles.imageWrapper, imageProps?.className)}
                    alt={imageProps?.alt || ''}
                />
            )}
            <Text
                showIf={!!descriptionContent}
                size="small"
                className={cn(styles.description, descriptionProps?.className)}
                {...descriptionProps}
            >
                {descriptionContent}
            </Text>
            <div className={styles.actionWrapper}>
                <Button showIf={!!buttonProps} className={cn(styles.button, buttonProps?.className)} {...buttonProps} />
            </div>
        </Card>
    );
};
